import React from "react";
import { color } from "../../styles/theme";

const VARIANTS = {
  neutral: { bg: color.gray100, fg: color.gray700 },
  success: { bg: color.success50, fg: color.success700 },
  danger: { bg: color.danger50, fg: color.danger600 },
  warning: { bg: color.warning50, fg: color.warning500 },
  info: { bg: color.info50, fg: color.info500 },
  primary: { bg: color.primary50, fg: color.primary700 },
};

/** Small status pill — consistent replacement for every page's own ad-hoc badge object. */
const Badge = ({ children, variant = "neutral", dot = false }) => {
  const v = VARIANTS[variant] || VARIANTS.neutral;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 5,
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: 0.2,
        padding: "3px 9px",
        borderRadius: 999,
        background: v.bg,
        color: v.fg,
        lineHeight: 1.5,
      }}
    >
      {dot && <span style={{ width: 5, height: 5, borderRadius: "50%", background: "currentColor" }} />}
      {children}
    </span>
  );
};

export default Badge;
